export default __webpack_public_path__ + "static/media/screen.4ee4ed8c.gif";